site.videoPlayButton = {
	init: function () {
		$('iframe[data-src*="youtube.com"]').each(function() {
			var $this = $(this),
				src = $this.data('src'),
				videoID = site.videoPlayButton.getYoutubeVideoID(src);

			if (!videoID) {
				$this.remove();
				return;
			}

			$this.attr('allowfullscreen','').wrap(
				'<div class="video__playButton">' +
					'<div class="embed-responsive embed-responsive-16by9"></div>' +
				'</div>'
			);
			var $div = $this.closest('.video__playButton'),
				thumbnail = 'https://img.youtube.com/vi/' + videoID + '/mqdefault.jpg',
				button = '<button class="play" style="background-image:url(' + thumbnail+ ')"></button>';
			$div.prepend(button);

			var $button = $div.find('button.play');
			$button.on('click', function() {
				$div.find('iframe').prop('src', 'https://www.youtube.com/embed/' + videoID + '?autoplay=1');
				$(this).addClass('clicked');
			});

		});
	},

	getYoutubeVideoID: function(url) {
		var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
		var match = url.match(regExp);
		if (match && match[2].length == 11) {
			return match[2];
		}
		return false;
	}
};

site.inits.push('site.videoPlayButton.init()');